import './jquery-zoom.mjs';

export const pdpZoom = () => {
  $(document).on('mouseover', '.thumbs a:not(.zoom-ready)', function (event) {
    const $a = $(event.currentTarget);
    const $zoomLoader = $a.find('.zoom-loader')
    $a.addClass('zoom-ready');
    $zoomLoader.addClass('show');
    // const $img = $a.find('img');

    // @ts-ignore
    $a.zoom({
      url: event.currentTarget.getAttribute('zoom'),
      callback: function () {
        // $(this).css({
        //   marginLeft: `-${$img.width()}px`, // fix zoom position
        // });
        $a.trigger('mouseenter.zoom');
        $zoomLoader.removeClass('show');
      },
    });
    // 
  });
  $('.thumbs a').removeAttr('title');

};

const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0;
if (!isTouchDevice) {
  pdpZoom();
}
